import { db, fb, functions } from "../firebase";
import { makeid } from "./pageactions";
const _deletePage = functions.httpsCallable("deletePage");
export const addPage = (appId, name) => {
  return new Promise(async (resolve, reject) => {
    const id = makeid(24);
    await db.collection("apps").doc(appId).collection("pages").doc(id).set({
      name,
      editable: true,
      id: id,
    });

    await db
      .collection("apps")
      .doc(appId)
      .collection("pages")
      .doc(id)
      .collection("components")
      .doc(id)
      .set({
        children: [],
        component: "Page",
        name,
        props: { backgroundColor: "white", alignItems: "stretch" },
        stateVariables: [],
        id: id,
      });

    resolve(id);
  });
};

export const deletePage = async (appId, pageId) => {
  await _deletePage({ appId, type: "pages", pageId });
  return;
};

export const addComponent = async (appId, name) => {
  console.log("Adding Component ", name);

  const batch = db.batch();
  const id = makeid(24).toUpperCase();
  batch.set(db.collection("apps").doc(appId).collection("components").doc(id), {
    name,
    editable: true,
    id: id,
    customProps: {},
  });
  batch.set(
    db
      .collection("apps")
      .doc(appId)
      .collection("components")
      .doc(id)
      .collection("components")
      .doc(id),
    {
      children: [],
      component: "Component",
      name,
      props: {
        backgroundColor: "white",
        type: "relative",
        backgroundColor: "white",
        justifyContent: "flex-start",
        size: { minWidth: 40, maxWidth: "", minHeight: 40, maxHeight: "" },
        flexGrow: 0,
      },
      stateVariables: [],
      customProps: {},
      id: id,
    }
  );

  await batch.commit();
  return id;
};

export const updateComponent = (appId, component) => {
  const _v = {};
  _v[component.key] = component.value;
  db.collection("apps")
    .doc(appId)
    .collection("components")
    .doc(component.id)
    .set(_v, { merge: true });
};

export const deleteComponent = async (appId, pageId) => {
  await _deletePage({ appId, type: "components", pageId });
  return;
};

export const updatePluginConfig = (app, plugin, conf) => {
  console.log(`updating ${plugin} plugin config`);
  db.collection("apps")
    .doc(app.id)
    .update({
      [`plugins.${plugin}.config`]: conf,
    });
  const newApp = JSON.parse(JSON.stringify(app));
  newApp.plugins[plugin].config = conf;
  return newApp;
};

export const updatePluginVersion = (app, plugin, version) => {
  console.log(`updating ${plugin} plugin version`);
  db.collection("apps")
    .doc(app.id)
    .update({
      [`plugins.${plugin}.version`]: version,
    });
  const newApp = JSON.parse(JSON.stringify(app));
  newApp.plugins[plugin].version = version;
  return newApp;
};

export const addPlugin = (app, plugin, id, version, config) => {
  console.log(`adding ${plugin} plugin to app`);
  const data = {
    name: plugin,
    version: version,
    config: config,
  };
  db.collection("apps")
    .doc(app.id)
    .update({
      [`plugins.${id}`]: data,
    });
  const newApp = JSON.parse(JSON.stringify(app));
  newApp.plugins[id] = data;
  return newApp;
};

export const addRole = (app, roleId, roleName) => {
  console.log(`adding new role ${roleName} to app`);
  db.collection("apps")
    .doc(app.id)
    .update({ [`roles.${roleId}`]: roleName });
  const newApp = JSON.parse(JSON.stringify(app));
  newApp.roles[roleId] = roleName;
  return newApp;
};

export const deleteRole = (app, roleId) => {
  const update = {
    [`roles.${roleId}`]: fb.firestore.FieldValue.delete(),
  };
  db.collection("apps").doc(app.id).update(update);
  const newApp = JSON.parse(JSON.stringify(app));
  delete newApp.roles[roleId];
  return newApp;
};

export const updateRoleName = (app, roleId, name) => {
  console.log("updating role name");
  db.collection("apps")
    .doc(app.id)
    .update({
      [`roles.${roleId}`]: name,
    });
  const newApp = JSON.parse(JSON.stringify(app));
  newApp.roles[roleId] = name;
  return newApp;
};
